var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hgReportCoverImage)?_c('div',{staticClass:"hero-image cover",style:({ backgroundImage: 'url(' + _vm.hgReportCoverImage + ')' })}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }